//This file is automatically rebuilt by the Cesium build process.
export default "const float czm_epsilon1 = 0.1;\n\
";
